import { render } from "./InputTags.vue?vue&type=template&id=20f9e38e&scoped=true"
import script from "./InputTags.vue?vue&type=script&lang=ts"
export * from "./InputTags.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-20f9e38e"

export default script